/**
 * Swiper 7.4.1
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination, freemode & keyboard modules:
import Swiper, { Navigation, Pagination, FreeMode, Keyboard } from 'swiper';

const gammeProducts = document.querySelectorAll('.js-gamme-products');

if (gammeProducts.length) {
  for (const swiper of gammeProducts) {

    // Swiper instance
    const gammeProductsInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, Keyboard],
      slidesPerView: 'auto',
      loop: false,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el:  swiper.querySelector('.swiper-pagination'),
        clickable: true
      },
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide');

    if (nbSlides.length > 2) {
      gammeProductsInstance.init();
    }
  }
}

/**
* Page Standard Swiper
* Default + freemode
*/
// Default
const psSwiper = document.querySelectorAll('.js-swiper-page-standard');

if (psSwiper.length) {
  for (const swiper of psSwiper) {

    // Swiper instance
    const psSwiperInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, Keyboard],
      slidesPerView: 1,
      loop: true,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el:  swiper.querySelector('.swiper-pagination'),
        clickable: true
      },
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide');

    if (nbSlides.length > 1) {
      psSwiperInstance.init();
    }
  }
}

// Freemode
const swiperFreemode = document.querySelectorAll('.js-swiper-freemode');
if (swiperFreemode.length) {
  for (const swiper of swiperFreemode) {

    // Swiper instance
    const swiperFreeModeInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, FreeMode, Keyboard],
      slidesPerView: 'auto',
      centeredSlides: (Foundation.MediaQuery.current === 'small') ? false : true,
      grabCursor: true,
      freeMode: true,
      spaceBetween: (Foundation.MediaQuery.current === 'small') ? 15 : 30,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide');

    if (nbSlides.length > 1) {
      swiperFreeModeInstance.init();
    }
  }
}

const filterSwipersSwiping = (swiperEl) => {
  const slides = swiperEl.querySelectorAll('.swiper-slide');
  const swiperWidth = swiperEl.clientWidth;
  const slidesWidth = () => {
    let width = 0;
    for (let index = 0; index < slides.length; index++) {
      const slide = slides[index];
      width += slide.clientWidth;
      if (index < slides.length - 1) {
        width += 10;
      }
    }
    return width;
  }
  swiperEl.classList.toggle('swiper-no-swiping', swiperWidth > slidesWidth());
}

const filterSwipers = document.querySelectorAll('.js-swiper-filters');
if (filterSwipers.length) {
  const updateSwiperBackground = (swiper) => {
    swiper.$el[0].classList.toggle(
      'swiper-container--prev',
      !swiper.navigation.prevEl.classList.contains('swiper-button-disabled')
    )
    swiper.$el[0].classList.toggle(
      'swiper-container--next',
      !swiper.navigation.nextEl.classList.contains('swiper-button-disabled')
    )
  };

  for (const swiper of filterSwipers) {

    // Swiper instance
    const filterSwipersInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, FreeMode, Keyboard],
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      spaceBetween: 10,
      init: false,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      on: {
        resize: (swiper) => {
          filterSwipersSwiping(swiper.$el[0]);
          updateSwiperBackground(swiper);
        },
        afterInit: (swiper) => {
          setTimeout(() => {
            swiper.update();
            filterSwipersSwiping(swiper.$el[0]);
          }, 1000);
        },
        update: updateSwiperBackground,
        transitionStart: updateSwiperBackground,
        transitionEnd: updateSwiperBackground
      }
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide');

    if (nbSlides.length > 1) {
      filterSwipersInstance.init();
    }
  }
}
